exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fa-stack.small[data-v-3490502f] { font-size: 0.7em;\n}\n.fa-comment[data-v-3490502f] { \n    position: relative;\n    top: 2px;\n}\n", ""]);

// exports
